import { APISlideAttributes } from '@ardoq/api-types';

export const getSlideTitle = (slide: APISlideAttributes | null): string =>
  slide?.name.trim() ?? '';
